// What an Audit picker currently means, as three states that can't be
// confused: nothing chosen, an existing audit chosen by id, or a new audit to
// be created under `name` on save.
//
// The id is load-bearing. Audit names are not unique — two Optro audits
// routinely carry the same title and they are two audits (SOX-108064) — so a
// name can create one but can never select one.

export type OpsAuditSelection =
  | { kind: "none" }
  | { kind: "existing"; id: string }
  | { kind: "new"; name: string };

export const noOpsAudit: OpsAuditSelection = { kind: "none" };

export const opsAuditSelectionsMatch = (
  a: OpsAuditSelection,
  b: OpsAuditSelection,
): boolean => {
  if (a.kind === "existing" && b.kind === "existing") return a.id === b.id;
  if (a.kind === "new" && b.kind === "new") return a.name === b.name;
  return a.kind === b.kind;
};
